var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useImperativeHandle, useRef, useState, } from 'react';
import styled, { css } from 'styled-components';
import { SAInputContainer } from '../input';
var StyledInputContainer = styled(SAInputContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var rows = _a.rows;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .textLikeInputWrapper textarea {\n      min-height: 19px;\n    }\n    ", "\n  "], ["\n    .textLikeInputWrapper textarea {\n      min-height: 19px;\n    }\n    ",
        "\n  "])), rows && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .textLikeInputWrapper textarea {\n      height: auto;\n    "], ["\n    .textLikeInputWrapper textarea {\n      height: auto;\n    "]))));
});
export var SATextArea = React.forwardRef(function (_a, ref) {
    var id = _a.id, backgroundColor = _a.backgroundColor, hint = _a.hint, icon = _a.icon, iconSize = _a.iconSize, iconColor = _a.iconColor, label = _a.label, onClickIcon = _a.onClickIcon, color = _a.color, className = _a.className, error = _a.error, theme = _a.theme, variant = _a.variant, value = _a.value, fullWidth = _a.fullWidth, InputLabelProps = _a.InputLabelProps, rows = _a.rows, additionalProps = __rest(_a, ["id", "backgroundColor", "hint", "icon", "iconSize", "iconColor", "label", "onClickIcon", "color", "className", "error", "theme", "variant", "value", "fullWidth", "InputLabelProps", "rows"]);
    var _b = useState((InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.shrink) || !!value || !!additionalProps.defaultValue), shrinkLabel = _b[0], setShrinkLabel = _b[1];
    useEffect(function () {
        if (!!value || !!additionalProps.defaultValue) {
            setShrinkLabel(true);
        }
    }, [value, additionalProps.defaultValue]);
    var inputRef = useRef();
    useImperativeHandle(ref, function () { return inputRef.current; });
    return (React.createElement(StyledInputContainer, { id: id, backgroundColor: backgroundColor, hint: hint, icon: icon, iconSize: iconSize, iconColor: iconColor, label: label, onClickIcon: onClickIcon, className: "sa-textarea " + (className || ''), color: color, error: error, theme: theme, variant: variant, fullWidth: fullWidth, value: value, InputLabelProps: { shrink: shrinkLabel }, rows: rows },
        React.createElement("textarea", __assign({}, additionalProps, { ref: inputRef, value: value, onChange: function (evt) {
                if (additionalProps.onChange) {
                    additionalProps.onChange(evt);
                }
                var input = evt.target;
                if (input.value !== '') {
                    setShrinkLabel(true);
                }
                else {
                    setShrinkLabel(false);
                }
            } }))));
});
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=textarea.component.js.map